// extracted by mini-css-extract-plugin
module.exports = {"radio":"ProoferCard_radio__772JJ","card":"ProoferCard_card__4qNWd"};